import { createElement, Component, cloneElement } from 'react';
import { useUniqueId } from './uniqueId.js';
import { string, oneOfType, element, func, bool, shape } from 'prop-types';
import { withTheme } from 'reakit/styled';
import _get from 'lodash/get';
import './styled/index.js';
import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _omit from 'lodash/omit';
import Icon from './Icon/index.js';
import VisuallyHidden from './VisuallyHidden.js';
import Text from './Text/index.js';
import Hidden from './Hidden/index.js';
import { a as popoverPropTypes } from './chunk-8dd1e1d3.js';
import _FieldWrapper, { Label, OptionalText, RequiredText, TooltipButton, TooltipPopover, DescriptionText, HintText, ValidationText } from './FieldWrapper/styled.js';

var OutsideClickHandler = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OutsideClickHandler, _React$Component);

  function OutsideClickHandler() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      // `capture` flag is set to true so that a `stopPropagation` in the children
      // will not prevent all outside click handlers from firing - maja
      // @ts-ignore
      _this.clickHandle = window.addEventListener('click', _this.onOutsideClick);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      // @ts-ignore
      if (_this.clickHandle) {
        // @ts-ignore
        window.removeEventListener(_this.clickHandle);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOutsideClick", function (e) {
      // @ts-ignore
      var onOutsideClick = _this.props.onOutsideClick; // @ts-ignore

      var _assertThisInitialize = _assertThisInitialized(_this),
          childNode = _assertThisInitialize.childNode;

      var isDescendantOfRoot = childNode && childNode.contains(e.target);

      if (!isDescendantOfRoot) {
        onOutsideClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setChildNodeRef", function (ref) {
      // @ts-ignore
      _this.childNode = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return createElement(Box, {
        ref: _this.setChildNodeRef
      }, _this.props.children);
    });

    return _this;
  }

  return OutsideClickHandler;
}(Component); // @ts-ignore


OutsideClickHandler.defaultProps = {
  children: createElement("span", null),
  onOutsideClick: function onOutsideClick() {}
};

var FieldWrapper = function FieldWrapper(_ref) {
  var _a11yId = _ref.a11yId,
      children = _ref.children,
      description = _ref.description,
      hint = _ref.hint,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      label = _ref.label,
      state = _ref.state,
      tooltip = _ref.tooltip,
      _tooltipPopoverProps = _ref.tooltipPopoverProps,
      _tooltipTrigger = _ref.tooltipTrigger,
      validationText = _ref.validationText,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "children", "description", "hint", "isOptional", "isRequired", "label", "state", "tooltip", "tooltipPopoverProps", "tooltipTrigger", "validationText"]);

  var tooltipPopoverProps = _get(props, 'theme.fannypack.FieldWrapper.defaultProps.tooltipPopoverProps', _tooltipPopoverProps);

  var tooltipTrigger = _get(props, 'theme.fannypack.FieldWrapper.defaultProps.tooltipTrigger', _tooltipTrigger);

  var uid = useUniqueId('FieldWrapper');
  var a11yId = _a11yId || uid;
  var elementProps = {
    isRequired: isRequired,
    a11yId: a11yId,
    state: state
  };
  return createElement(_FieldWrapper, props, label && createElement(Box, {
    marginBottom: "minor-2"
  }, createElement(Flex, {
    alignItems: "center",
    lineHeight: "1"
  }, typeof label === 'string' ? createElement(Label, {
    htmlFor: a11yId
  }, label) : label, isOptional && createElement(OptionalText, null, "OPTIONAL"), isRequired && createElement(RequiredText, null, "*"), tooltip && createElement(Hidden.Container, null, function (hidden) {
    return (// @ts-ignore
      createElement(OutsideClickHandler, {
        onOutsideClick: hidden.hide
      }, createElement(Box, {
        relative: true
      }, tooltipTrigger ? // @ts-ignore
      cloneElement(tooltipTrigger, {
        onClick: hidden.toggle
      }) : // @ts-ignore
      createElement(TooltipButton, {
        onClick: hidden.toggle,
        kind: "ghost",
        size: "small"
      }, createElement(VisuallyHidden, null, "Toggle tooltip"), createElement(Icon, {
        a11yHidden: true,
        icon: "question-circle"
      })), hidden.isVisible && createElement(TooltipPopover, _extends({
        elevation: "200"
      }, tooltipPopoverProps), typeof tooltip === 'string' ? createElement(Text, {
        fontSize: "150"
      }, tooltip) : tooltip)))
    );
  })), typeof description === 'string' ? createElement(DescriptionText, null, description) : createElement("div", null, description)), typeof children === 'function' ? children({
    elementProps: elementProps
  }) : cloneElement(children, elementProps), typeof hint === 'string' ? createElement(HintText, null, hint) : createElement("div", null, hint), validationText && createElement(ValidationText, {
    color: state
  }, validationText));
};

var fieldWrapperPropTypes = {
  a11yId: string,
  children: oneOfType([element, func]).isRequired,
  className: string,
  description: oneOfType([string, element]),
  hint: oneOfType([string, element]),
  isOptional: bool,
  isRequired: bool,
  label: oneOfType([string, element]),
  state: string,
  tooltip: oneOfType([string, element]),
  tooltipPopoverProps: shape(_omit(popoverPropTypes, 'children', 'content')),
  tooltipTrigger: element,
  validationText: string
};
var fieldWrapperDefaultProps = {
  a11yId: undefined,
  className: undefined,
  description: undefined,
  hint: undefined,
  isOptional: undefined,
  isRequired: undefined,
  label: undefined,
  state: undefined,
  tooltip: undefined,
  tooltipPopoverProps: undefined,
  tooltipTrigger: undefined,
  validationText: undefined
};
FieldWrapper.defaultProps = fieldWrapperDefaultProps; // @ts-ignore

var C = withTheme(FieldWrapper);
export { C as a, fieldWrapperPropTypes as b, fieldWrapperDefaultProps as c };